import { Typography } from '@material-ui/core';
import React from 'react';

const CurrentTabDescription = ({ project }) => (
    <Typography variant="h6" align="left" gutterBottom>{`Project: ${project.name}`}</Typography>
);

export default CurrentTabDescription;
